import type { ArticleStatus } from '@/api/types';
import type { BadgeTone } from '@/components/ui';

export const ARTICLE_TONE: Record<ArticleStatus, BadgeTone> = {
  published: 'green',
  draft: 'amber',
  archived: 'neutral',
};
